import React, { useContext } from "react";
import { CartContext } from "../context/cart-context";
import CartColumns from "./CartColumns";
import CartItem from "./CartItem";
import CartTotals from "./CartTotals";

const CartList = () => {
  const cart = useContext(CartContext);

  return (
    <div className="container-fluid mx-2">
      <CartColumns />
      {cart.cart.map((item) => {
        return (
          <CartItem
            key={item.id}
            id={item.id}
            image={item.image}
            price={item.price}
            quantity={item.quantity}
            title={item.title}
            total={item.total}
            stock={item.inStock}
          />
        );
      })}
      <CartTotals />
    </div>
  );
};

export default CartList;
